import { Group, Loader } from '@mantine/core';

type WorkspaceTabLabelProps = {
  label: string;
  loading?: boolean;
};

export function WorkspaceTabLabel({
  label,
  loading = false,
}: WorkspaceTabLabelProps) {
  return (
    <Group
      gap={8}
      wrap='nowrap'
      aria-busy={loading}
      style={loading ? { opacity: 1 } : undefined}
    >
      {loading ? (
        <Loader size={14} type='dots' style={{ flexShrink: 0 }} />
      ) : null}
      <span>{label}</span>
    </Group>
  );
}
